import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { withConfig } from 'src/withConfig';
import { css, SerializedStyles } from '@emotion/react';
import { NumberIcon1, NumberIcon10, NumberIcon2, NumberIcon3, NumberIcon4, NumberIcon5, NumberIcon6, NumberIcon7, NumberIcon8, NumberIcon9 } from 'src/domains/casino/webview/CasinoGames/home-games/games-home-view/games-numeric-slider/numeric-slider-icons/NumberIcons';

const slideNumberIconStyles = (theme: EmotionTheme): SerializedStyles => {
    return css`
        color: ${theme.star.casino.casinoSlider.bgColor};
        height: 70px;
        inset: auto auto 0 0;
        mask-image: linear-gradient(to left, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 1) 100%);
        mask-repeat: no-repeat;
        mask-size: cover;
        position: absolute;
        width: auto;
        @media ${theme.star.mediaQuery.tablet} {
            height: 130px;
        }
    `;
};


export const SlideNumberIcon1 = withConfig(theme => styled(NumberIcon1, { label: 'SlideNumberIcon1' })`
    ${slideNumberIconStyles(theme)};
`);

export const SlideNumberIcon2 = withConfig(theme => styled(NumberIcon2, { label: 'SlideNumberIcon2' })`
    ${slideNumberIconStyles(theme)};
`);

export const SlideNumberIcon3 = withConfig(theme => styled(NumberIcon3, { label: 'SlideNumberIcon3' })`
    ${slideNumberIconStyles(theme)};
`);

export const SlideNumberIcon4 = withConfig(theme => styled(NumberIcon4, { label: 'SlideNumberIcon4' })`
    ${slideNumberIconStyles(theme)};
`);

export const SlideNumberIcon5 = withConfig(theme => styled(NumberIcon5, { label: 'SlideNumberIcon5' })`
    ${slideNumberIconStyles(theme)};
`);

export const SlideNumberIcon6 = withConfig(theme => styled(NumberIcon6, { label: 'SlideNumberIcon6' })`
    ${slideNumberIconStyles(theme)};
`);

export const SlideNumberIcon7 = withConfig(theme => styled(NumberIcon7, { label: 'SlideNumberIcon7' })`
    ${slideNumberIconStyles(theme)};
`);

export const SlideNumberIcon8 = withConfig(theme => styled(NumberIcon8, { label: 'SlideNumberIcon8' })`
    ${slideNumberIconStyles(theme)};
`);

export const SlideNumberIcon9 = withConfig(theme => styled(NumberIcon9, { label: 'SlideNumberIcon9' })`
    ${slideNumberIconStyles(theme)};
`);

export const SlideNumberIcon10 = withConfig(theme => styled(NumberIcon10, { label: 'SlideNumberIcon10' })`
    ${slideNumberIconStyles(theme)};
`);

export const GameNumericWrapper = withConfig(theme => styled('div', { label: 'GameNumericWrapper' })`
    overflow: hidden;
    position: relative;
    width: 158px;
    height: 175px;
    &:last-of-type {
        margin-right: 0;
    }
    @media ${theme.star.mediaQuery.tablet} {
        width: 315px;
        height: 350px;
    }
`);

export const GameNumericImgWrapper = withConfig(theme => styled('div', { label: 'GameNumericImgWrapper' })`
    position: relative;
    width: 130px;
    height: 175px;
    margin-left: auto;
    &:hover > div {
        opacity: .8;
        visibility: visible;
    }
    @media ${theme.star.mediaQuery.tablet} {
        width: 260px;
        height: 350px;
    }
`);
